module.exports = __webpack_public_path__ + "static/media/IMG_0008.9b759d12.jpg";